import { appleProvider, firebaseAuth, useUserStore } from "@/entities"
import {
  authControllerSocialAuth,
  SocialAuthDtoRegisteredDevice,
} from "@/shared/api/generated"
import { DEFAULT_VOICE_DATA_FOR_REGISTER } from "@/shared/constants"
import { notifyMeasurer } from "@/shared/utils/notify-measurer"
import { signInWithPopup } from "firebase/auth"
import { useState } from "react"

export const useAppleAuth = () => {
  const [isLoading, setIsLoading] = useState(false)
  const userStore = useUserStore()

  const signInWithApple = async () => {
    try {
      setIsLoading(true)
      const result = await signInWithPopup(firebaseAuth, appleProvider)
      const token = await result.user.getIdToken()
      const { access_token, is_registered_now } =
        await authControllerSocialAuth({
          registeredDevice: SocialAuthDtoRegisteredDevice.WEBSITE,
          token,
          voiceId: DEFAULT_VOICE_DATA_FOR_REGISTER.VOICE_ID,
          voiceLang: DEFAULT_VOICE_DATA_FOR_REGISTER.VOICE_LANG,
        })

      await userStore.login(access_token)
      if (is_registered_now) {
        notifyMeasurer()
      }
      setIsLoading(false)
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    signInWithApple,
    isLoading,
  }
}
